export default __webpack_public_path__ + "static/media/frame424N.45212d93.svg";